export const SELECT_DATASOURCE = "SELECT_DATASOURCE";
export const SELECT_VERTEXEDGE_MAPPER = "SELECT_VERTEXEDGE_MAPPER";
export const SELECT_NODELINK_MAPPER = "SELECT_NODELINK_MAPPER";
export const CREATE_PREVIEW_VISUALIZATION = "CREATE_PREVIEW_VISUALIZATION";
export const UPDATE_RENDERING_MODULE_CONFIG = "UPDATE_RENDERING_MODULE_CONFIG";
